import { createSlice } from "@reduxjs/toolkit";
import { getBetCategories, getBetQuestions, placeBet, getUserBets, getQuestionDetails, cashoutBet, getRelatedMarkets } from "./prediqoActions";

const initialState = {
  loading: false,
  categoriesLoading: false,
  questionsLoading: false,
  placingBet: false,
  userBetsLoading: false,
  categories: [],
  questions: [],
  questionsCount: 0, // Total count for pagination
  userBets: [],
  userBetsCount: 0, // Total count for user bets pagination
  selectedCategory: { id: 0, name: "Trending" }, // Default to Trending
  betResult: null,
  error: null,
  relatedMarkets: [],
  relatedMarketsLoading: false,
  relatedMarketsError: null,
};

const prediqoSlice = createSlice({
  name: "prediqo",
  initialState,
  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    clearBetResult: (state) => {
      state.betResult = null;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: {
    // =============================== GET BET CATEGORIES
    [getBetCategories.pending]: (state) => {
      state.categoriesLoading = true;
      state.error = null;
    },
    [getBetCategories.fulfilled]: (state, { payload }) => {
      state.categoriesLoading = false;
      state.categories = payload.data.betCategories || payload; // Handle different response structures
    },
    [getBetCategories.rejected]: (state, { payload }) => {
      state.categoriesLoading = false;
      state.error = payload?.data?.message || "Failed to fetch categories";
    },

    // =============================== GET BET QUESTIONS
    [getBetQuestions.pending]: (state) => {
      state.questionsLoading = true;
      state.error = null;
    },
    [getBetQuestions.fulfilled]: (state, { payload }) => {
      state.questionsLoading = false;
      state.questions = payload.data.questions || payload;
      state.questionsCount = payload.meta?.count || 0; // Extract count from meta
    },
    [getBetQuestions.rejected]: (state, { payload }) => {
      state.questionsLoading = false;
      state.error = payload?.data?.message || "Failed to fetch questions";
    },

    // =============================== PLACE BET
    [placeBet.pending]: (state) => {
      state.placingBet = true;
      state.error = null;
    },
    [placeBet.fulfilled]: (state, { payload }) => {
      state.placingBet = false;
      state.betResult = payload;
    },
    [placeBet.rejected]: (state, { payload }) => {
      state.placingBet = false;
      state.error = payload?.data?.message || "Failed to place bet";
    },

    // =============================== GET USER BETS
    [getUserBets.pending]: (state) => {
      state.userBetsLoading = true;
      state.error = null;
    },
    [getUserBets.fulfilled]: (state, { payload }) => {
      state.userBetsLoading = false;
      state.userBets = payload.data.bets || payload;
      state.userBetsCount = payload.meta?.count || 0; // Extract count from meta if available
    },
    [getUserBets.rejected]: (state, { payload }) => {
      state.userBetsLoading = false;
      state.error = payload?.data?.message || "Failed to fetch user bets";
    },

    // ==================== GET QUESTION DETAILS
    [getQuestionDetails.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getQuestionDetails.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.betDetails = payload.data.question || payload; 
    },
    [getQuestionDetails.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload?.data?.message || "Failed to fetch bet details";
    } ,

    // CASH OUT BET
    [cashoutBet.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [cashoutBet.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
     [cashoutBet.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload?.data?.message || "Failed to cash out bet";
   },
    //  related markets
    [getRelatedMarkets.pending]: (state) => {
      state.relatedMarketsLoading = true;
      state.relatedMarketsError = null;
    },
    [getRelatedMarkets.fulfilled]: (state, { payload }) => {
      state.relatedMarketsLoading = false;
      console.log(payload);
      state.relatedMarkets = payload.data;
    },
    [getRelatedMarkets.rejected]: (state, { payload }) => {
      state.relatedMarketsLoading = false;
      state.relatedMarketsError = payload?.data?.message || "Failed to fetch related markets";
    }
  },
});

export const { setSelectedCategory, clearBetResult, clearError } = prediqoSlice.actions;
export default prediqoSlice.reducer;